/**
 * The narrowest the table may be drawn before its columns start overlapping.
 *
 * The table is laid out `table-layout: fixed`, so a column with a declared pixel width never shrinks
 * and any remaining space is split between the columns that declare none. Once the fixed widths
 * exceed the container, that remainder goes negative and those columns collapse to nothing, painting
 * their contents over the next column. Holding the table to this width instead lets it scroll.
 *
 * Returns null where no honest sum exists — no columns at all, or a width in units that cannot be
 * added to pixels.
 */
const FLEXIBLE_COLUMN_FLOOR_PX = 180;

export function tableMinWidth(columns: { width?: string }[]): number | null {
  if (columns.length === 0) return null;

  let total = 0;

  for (const column of columns) {
    if (!column.width) {
      total += FLEXIBLE_COLUMN_FLOOR_PX;
      continue;
    }

    const pixels = toPixels(column.width);
    if (pixels === null) return null;
    total += pixels;
  }

  return total;
}

function toPixels(width: string): number | null {
  const match = /^(\d+(?:\.\d+)?)px$/.exec(width.trim());
  return match ? Number(match[1]) : null;
}
